import React, { useContext } from "react";
import {Box, Icon, Skeleton, Table, TableCell, TableHeading, Text, ToggleButton} from "@nike/eds";
import SnackbarContext from "../../providers/snackbar-context";
import "./EntryContextOverview.css";
import useSWR from "swr";
import DateTimeFormat from "../shared/DateTimeFormat";
import {Link} from "react-router-dom";

export function EntryContextOverview({ inventoryService, LocationTracker }) {
    const snackbarCtx = useContext(SnackbarContext);

    const fetcher = async () => {
        try {
            const result = await inventoryService.listFallbackEntryContexts();
            return result.data.entryContextFallbackSearch.items || [];
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
            snackbarCtx.displayMsg(errorMessage, "error");
            throw error;
        }
    };

    const { data: entryContexts = [], isLoading } = useSWR(
        "entryContextFallbackSearch",
        fetcher,
        { refreshInterval: 60000 }
    );

    const headers = [
        { Header: "Material" },
        { Header: "Size" },
        { Header: "MCO" },
        { Header: "Quality" },
        { Header: "Det. Unit Price (CRP) (USD)" },
        { Header: "Calculation Timestamp" },
        { Header: "Entry Trigger" },
        { Header: "Entry Timestamp" },
        { Header: "Link to Entry Event" }
    ];

    const triggerType = (type: string) => {
        switch (type) {
            case "NODE_INVENTORY_ADJUSTMENT":
                return "Node Inventory Adjustment";
            case "CUSTOMS_INVENTORY_ADJUSTMENT":
                return "Customs Inventory Adjustment";
            case "UNEXPECTED_RECEIPT":
                return "Unexpected Receipt";
            default:
                return type;
        }
    };

    return (
        <div>
            <Text style={{ marginBottom: "1rem", fontWeight: "bold" }} font={"display-3"} as={"h3"}>
                Entry Context Corrections
            </Text>
            <Box className="eds-grid-ec eds-elevation--4">
                <ToggleButton className="eds-toggle-button-ec" active={true}> Determined Purchase Entry Context - Fallback</ToggleButton>

                <Table>
                    <thead>
                    <tr>
                        {headers.map((column) => (
                            <TableHeading key={column.Header}>{column.Header}</TableHeading>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading &&
                        <tr>
                            {headers.map((_, index) => (
                                <TableCell key={index}><Skeleton height={35} width={"100%"}/></TableCell>
                            ))}
                        </tr>
                    }
                    {!isLoading && !entryContexts?.length &&
                        <tr>
                            <TableCell colSpan={6}>No entry contexts found</TableCell>
                        </tr>
                    }
                    {!isLoading && entryContexts?.length > 0 &&
                        entryContexts.map((item) => (
                            <tr key={item.entryContextKey}>
                                <TableCell>{item.material}</TableCell>
                                <TableCell>{item.size}</TableCell>
                                <TableCell>{item.mco}</TableCell>
                                <TableCell>{item.quality}</TableCell>
                                <TableCell>{item.determinedUnitPrice}</TableCell>
                                <TableCell> - </TableCell>
                                <TableCell>{triggerType(item.entryTriggerType)}</TableCell>
                                <TableCell>
                                    <DateTimeFormat timestamp={item.entryTimestamp} format="dd/MM/yyyy - HH:mm"/>
                                </TableCell>
                                <TableCell>
                                    <Link to={"/flow-overview?flowId=" + item.flowId} reloadDocument>
                                        <Icon name="Show" size="m"/>
                                    </Link>
                                </TableCell>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Box>
            <LocationTracker location="Entry Context Overview" sublocation="Overview" />
        </div>
    );
}